import React, { useState, useRef, useEffect } from 'react';
import { apiHolder as api, apis } from 'api';
import styles from './preview.module.scss';
import { mailTemplatePreviewWrapper } from '@web-mail/components/ReadMail/util';
import { mailStrDecode } from './util';
import { getIn18Text } from 'api';
const templateApi = api.api.requireLogicalApi(apis.mailTemplateImplApi);
const Preview = (props) => {
    var _a, _b, _c, _d, _e;
    const { templateId, defaultTemplateData } = props;
    const frameRef = useRef(null);
    const [templateData, setTemplateData] = useState({});
    const doGetMailTemplateDetail = () => {
        templateApi.doGetMailTemplateDetail({ templateId: templateId }).then(res => {
            res.data && setTemplateData(res.data);
        });
    };
    useEffect(() => {
        if (defaultTemplateData) {
            setTemplateData(defaultTemplateData);
        }
        else if (templateId) {
            doGetMailTemplateDetail();
        }
    }, [templateId, defaultTemplateData]);
    useEffect(() => {
        if (frameRef.current) {
            frameRef.current.setAttribute('style', 'padding:10px');
            const doc = frameRef.current.contentDocument;
            doc === null || doc === void 0 ? void 0 : doc.open();
            doc === null || doc === void 0 ? void 0 : doc.write(mailTemplatePreviewWrapper((templateData === null || templateData === void 0 ? void 0 : templateData.content) || ''));
            doc === null || doc === void 0 ? void 0 : doc.close();
        }
    }, [templateData]);
    const handleLoad = () => {
        var _a;
        if ((_a = frameRef.current) === null || _a === void 0 ? void 0 : _a.contentDocument) {
            const doc = frameRef.current.contentDocument;
            const bodyElements = doc.getElementsByTagName('body');
            const realCont = (bodyElements === null || bodyElements === void 0 ? void 0 : bodyElements.length) ? bodyElements[0] : null;
            let contentHeight = (realCont === null || realCont === void 0 ? void 0 : realCont.scrollHeight) || 0;
            frameRef.current.style.height = contentHeight ? contentHeight + 20 + 'px' : 'auto';
        }
    };
    const MailTag = (mailTagProps) => {
        const { mail } = mailTagProps;
        const { contactEmail, contactName } = mailStrDecode(mail);
        return React.createElement("p", { className: styles.contactsMail }, contactName || contactEmail);
    };
    return (React.createElement("div", { className: styles.mailTemplatePreviewBox },
        React.createElement("p", { className: styles.contacts },
            React.createElement("span", { className: styles.contactsTitle }, getIn18Text('SHOUJIANREN\uFF1A')), (_a = templateData === null || templateData === void 0 ? void 0 : templateData.to) === null || _a === void 0 ? void 0 :
            _a.map(_ => (React.createElement(MailTag, { mail: _ })))),
        React.createElement("p", { className: styles.contacts, hidden: ((_b = templateData.cc) === null || _b === void 0 ? void 0 : _b.length) <= 0 },
            React.createElement("span", { className: styles.contactsTitle }, getIn18Text('CHAO&#12')), (_c = templateData === null || templateData === void 0 ? void 0 : templateData.cc) === null || _c === void 0 ? void 0 :
            _c.map(_ => (React.createElement(MailTag, { mail: _ })))),
        React.createElement("p", { className: styles.contacts, hidden: ((_d = templateData.bcc) === null || _d === void 0 ? void 0 : _d.length) <= 0 },
            React.createElement("span", { className: styles.contactsTitle }, getIn18Text('MI&#12')), (_e = templateData === null || templateData === void 0 ? void 0 : templateData.bcc) === null || _e === void 0 ? void 0 :
            _e.map(_ => (React.createElement(MailTag, { mail: _ })))),
        React.createElement("p", { className: styles.contacts },
            React.createElement("span", { className: styles.contactsTitle }, getIn18Text('ZHU&#12')),
            React.createElement("span", { className: styles.mailTitle }, templateData === null || templateData === void 0 ? void 0 : templateData.subject)),
        React.createElement("p", { className: styles.content },
            React.createElement("iframe", { title: getIn18Text('YULAN'), ref: frameRef, width: "100%", height: "100%", src: "about:blank", frameBorder: "0", onLoad: handleLoad }))));
};
export default Preview;
